import React from 'react';

function Administration() {
  return (
    <div>Administration</div>
  );
}

export default Administration;